import React, { useEffect, useState } from "react";
import TeamOverview from "./TeamOverview";
import TeamMessages from "./TeamMessages";
import TeamsTasklist from "./TeamsTasklist";
import TeamsSharedfiles from "./SharedFiles/TeamsSharedfiles";
import { useRouteBaseStateContext } from "../../../../Context/RouteBaseStateContext";

export default function FullTeamOverview({ teamoverview }) {
  const [projectId, setProjectID] = useState(0);
  const [projectDetails, setProjectDetails] = useState([]);

  const { urlstate, setTeamroute } = useRouteBaseStateContext();
  const [serachkey, setSerachkey] = useState("");

  const [activeTab, setActiveTab] = useState("TeamOverview"); // State to manage active tab

  useEffect(() => {
    setSerachkey("");
    if (urlstate?.teamroute) {
      setActiveTab(urlstate?.teamroute || "TeamOverview");
    } else {
      setActiveTab("TeamOverview");
    }
  }, [urlstate, urlstate?.teamroute]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setTeamroute(tab);
  };


  return (
    <div>
      <div className="">
        <ul className="nav nav-tabs">
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab == "TeamOverview" ? "active" : ""}`}
              onClick={() => handleTabClick("TeamOverview")}
            >
              Team Overview
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab == "Messages" ? "active" : ""}`}
              onClick={() => handleTabClick("Messages")}
            >
              Messages
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab == "Tasklist" ? "active" : ""}`}
              onClick={() => handleTabClick("Tasklist")}
            >
              Tasklist
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link ${activeTab == "Sharedfiles" ? "active" : ""}`}
              onClick={() => handleTabClick("Sharedfiles")}
            >
              Shared files
            </a>
          </li>
        </ul>
        <div className="tab-content">
          <div
            className={`tab-pane ${activeTab == "TeamOverview" ? "active" : ""}`}
            id="TeamOverview"
          >
            <TeamOverview teamoverview={teamoverview} setTeamroute={setTeamroute} setProjectID={setProjectID} setProjectDetails={setProjectDetails} />
          </div>
          <div
            className={`tab-pane ${activeTab == "Messages" ? "active" : ""}`}
            id="Messages"
          >
            <TeamMessages teamoverview={teamoverview} />
          </div>
          <div
            className={`tab-pane ${activeTab == "Tasklist" ? "active" : ""}`}
            id="Tasklist"
          >
            <TeamsTasklist
              serachkey={serachkey}
              setSerachkey={setSerachkey}
              teamoverview={teamoverview}
              projectId={projectId}
              setProjectID={setProjectID}
              projectDetails={projectDetails}
              setProjectDetails={setProjectDetails}
            />
          </div>
          <div
            className={`tab-pane ${activeTab == "Sharedfiles" ? "active" : ""}`}
            id="Sharedfiles"
          >
            <TeamsSharedfiles teamoverview={teamoverview} />
          </div>
        </div>
      </div>
    </div>
  );
}
